import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCloudOfflineOutline, IoRefreshOutline } from 'react-icons/io5';
import './SlowLoading.css';

const SlowLoading = ({
  isLoading,
  onRetry,
  slowThreshold = 5000,    // 5 seconds - show "connecting" message
  retryThreshold = 10000,   // 10 seconds - show retry button
  showSkeleton = true,
  skeleton,
  children
}) => {
  const { t } = useTranslation();
  const [showSlow, setShowSlow] = useState(false);
  const [showRetry, setShowRetry] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowSlow(false);
      setShowRetry(false);
      return;
    }

    // Show slow message after slowThreshold
    const slowTimer = setTimeout(() => {
      setShowSlow(true);
    }, slowThreshold);

    // Show retry button after retryThreshold
    const retryTimer = setTimeout(() => {
      setShowRetry(true);
    }, retryThreshold);

    return () => {
      clearTimeout(slowTimer);
      clearTimeout(retryTimer);
    };
  }, [isLoading, slowThreshold, retryThreshold]);

  const handleRetry = () => {
    setShowSlow(false);
    setShowRetry(false);
    if (onRetry) {
      onRetry();
    }
  };

  if (!isLoading) {
    return children;
  }

  return (
    <div className="slow-loading-container">
      {showSkeleton && (
        <div className="slow-loading-skeleton">
          {skeleton || children}
        </div>
      )}

      {showSlow && (
        <div className={`slow-loading-message ${showRetry ? 'with-retry' : ''}`}>
          {showRetry ? (
            <>
              <IoCloudOfflineOutline className="slow-loading-icon" />
              <span className="slow-loading-text">{t('common.loadDataError')}</span>
              <button className="slow-loading-retry" onClick={handleRetry}>
                <IoRefreshOutline />
                <span>{t('chat.retry')}</span>
              </button>
            </>
          ) : (
            <>
              <div className="slow-loading-spinner" />
              <span className="slow-loading-text">{t('common.connectingToServer')}</span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SlowLoading;
